module.exports = __webpack_public_path__ + "media/images/favicon-f5c1754281968f68984733a306706f14.jpeg";